import { IconPropsType } from '..';

export const StatisticsIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.8501 3.78002H7.59974V12.3667H9.8501V3.78002Z"
      fill="#017F99"
    />
    <path
      d="M6.40023 5.92665H4.14987V12.3666H6.40023V5.92665Z"
      fill="#017F99"
    />
    <path
      d="M2.95036 8.07334H0.699997V12.3667H2.95036V8.07334Z"
      fill="#017F99"
    />
    <path
      d="M13.3 1.63333H11.0496V12.3666H13.3V1.63333Z"
      fill="#017F99"
    />
  </svg>
);
